export default {
  'alerts.pageTitle': '告警推送',
  'alerts.tab.channels': '通道',
  'alerts.tab.rules': '规则',
  'alerts.tab.events': '事件记录',

  // 通道
  'alerts.channels.name': '名称',
  'alerts.channels.type': '类型',
  'alerts.channels.enabled': '启用',
  'alerts.channels.summary': '配置摘要',
  'alerts.channels.actions': '操作',
  'alerts.channels.create': '新建通道',
  'alerts.channels.createTitle': '新建通道',
  'alerts.channels.editTitle': '编辑通道',
  'alerts.channels.delete': '删除',
  'alerts.channels.deleteConfirm': '删除该通道?',
  'alerts.channels.deleteHint': '已挂在规则上的会自动解绑',
  'alerts.channels.loadFailed': '加载失败',
  'alerts.channels.saveFailed': '保存失败',
  'alerts.channels.deleted': '已删除',
  'alerts.channels.deleteFailed': '删除失败',
  'alerts.channels.created': '已新建',
  'alerts.channels.updated': '已更新',
  'alerts.channels.toggleFailed': '切换失败',
  'alerts.channels.test': '测试推送',
  'alerts.channels.testOk': '测试推送成功,请到对应通道查收',
  'alerts.channels.testFailed': '测试失败',
  'alerts.channels.empty': '暂无通道,新建一个 Telegram / 钉钉 / 飞书 / Webhook 通道',

  'alerts.channels.tg.chatIdTip': '个人 chat_id 数字 / 群 -100xxx / @groupname',
  'alerts.channels.dd.secret': '加签密钥 (可选)',
  'alerts.channels.dd.secretTip': '钉钉机器人选「加签」时填,否则用关键字模式',
  'alerts.channels.dd.atUsers': '@用户 (可选)',
  'alerts.channels.dd.atUsersTip': '逗号分隔手机号',
  'alerts.channels.lark.secret': '加签密钥 (可选)',
  'alerts.channels.wb.signMethod': '签名方式',
  'alerts.channels.wb.secret': 'Secret',
  'alerts.channels.wb.secretTip': 'hmac-sha256 时必填',

  // 规则
  'alerts.rules.name': '名称',
  'alerts.rules.namePlaceholder': '如: Provider 异常推钉钉运维群',
  'alerts.rules.enabled': '启用',
  'alerts.rules.eventType': '事件类型',
  'alerts.rules.eventTypePlaceholder': '选择监听的事件',
  'alerts.rules.eventTypes': '监听事件',
  'alerts.rules.eventTypesPlaceholder': '选 1 个或多个事件',
  'alerts.rules.eventTypesRequired': '请选事件,或勾选「监听全部事件」',
  'alerts.rules.channels': '推送到通道',
  'alerts.rules.channelsPlaceholder': '选 1 个或多个通道',
  'alerts.rules.throttle': '节流秒数',
  'alerts.rules.throttleTip':
    '0 = 不节流(每条都推);> 0 = 同事件同通道在窗口内只推一次。推荐 300s(5 分钟)防告警风暴',
  'alerts.rules.throttleOff': '不节流',
  'alerts.rules.throttleZeroHint': '⚠ 当前为「不节流」,事件每次 PUB 都会推送,可能造成告警刷屏',
  'alerts.rules.allChannels': '推送到全部通道',
  'alerts.rules.allChannelsTip':
    '勾选后忽略下方通道选择,自动推送到所有启用的通道(含未来新建的),无需回头改规则',
  'alerts.rules.allChannelsTag': '全部通道',
  'alerts.rules.channelsRequired': '请选通道,或勾选「推送到全部通道」',
  'alerts.rules.allEvents': '监听全部事件',
  'alerts.rules.allEventsTip':
    '勾选后忽略下方事件选择,任何事件 PUB 都进此规则。常用于「全部告警都进运维总群」,不用一个事件配一条规则',
  'alerts.rules.allEventsTag': '全部事件',
  'alerts.rules.conditions': '触发条件 (JSON,可选)',
  'alerts.rules.conditionsTip':
    '示例: {"provider": "apimart"} 仅 apimart 触发;{"recovered_min": 10} 回收数 ≥ 10 触发。留空 = 无条件',
  'alerts.rules.conditionsInvalid': '条件 JSON 格式不合法',
  'alerts.rules.actions': '操作',
  'alerts.rules.create': '新建规则',
  'alerts.rules.createTitle': '新建规则',
  'alerts.rules.editTitle': '编辑规则',
  'alerts.rules.delete': '删除',
  'alerts.rules.deleteConfirm': '删除该规则?',
  'alerts.rules.deleted': '已删除',
  'alerts.rules.deleteFailed': '删除失败',
  'alerts.rules.created': '已新建',
  'alerts.rules.updated': '已更新',
  'alerts.rules.saveFailed': '保存失败',
  'alerts.rules.loadFailed': '加载失败',
  'alerts.rules.toggleFailed': '切换失败',
  'alerts.rules.emit': '触发一次',
  'alerts.rules.emitOk': '已触发,请到通道查收',
  'alerts.rules.emitFailed': '触发失败',
  'alerts.rules.empty': '暂无规则,新建一条把事件路由到通道',
  'alerts.rules.viewInCatalog': '点击查看事件说明',

  // 事件
  'alerts.events.sentAt': '时间',
  'alerts.events.eventType': '事件',
  'alerts.events.rule': '规则',
  'alerts.events.channel': '通道',
  'alerts.events.status': '状态',
  'alerts.events.title': '标题',
  'alerts.events.error': '错误',
  'alerts.events.detail': '事件详情',
  'alerts.events.loadFailed': '加载失败',
  'alerts.events.empty': '暂无事件,推送发生后会落在这里(全部保留,无过期)',

  // ===== 通道类型字典(Segmented label + Select Option 描述用)=====
  'alerts.channelType.telegram.label': 'Telegram',
  'alerts.channelType.telegram.desc': '官方 Bot API,免费,支持 Markdown',
  'alerts.channelType.dingtalk.label': '钉钉机器人',
  'alerts.channelType.dingtalk.desc': '钉钉群自定义机器人,可加签',
  'alerts.channelType.lark.label': '飞书 / Lark',
  'alerts.channelType.lark.desc': '飞书群自定义机器人,可加签',
  'alerts.channelType.webhook.label': '通用 Webhook',
  'alerts.channelType.webhook.desc': 'JSON POST,可对接 Slack / n8n / 自建系统',

  // ===== 事件类型字典(Select Option label + desc;Tag 显示同 label)=====
  'alerts.eventType.provider_error.label': 'Provider 调用异常',
  'alerts.eventType.provider_error.desc': '某供应商 1 分钟内失败率超阈值',
  'alerts.eventType.stale_recover.label': '卡死任务回收',
  'alerts.eventType.stale_recover.desc': '后台扫到超时未完成的任务被自动 fail',
  'alerts.eventType.llm_limiter.label': 'LLM 排队积压',
  'alerts.eventType.llm_limiter.desc': 'LLM 限流排队人数持续超阈值',
  'alerts.eventType.health.label': '服务健康',
  'alerts.eventType.health.desc': 'auth / drama / gateway 任一 /health 异常或恢复',
  'alerts.eventType.payment_paid.label': '充值到账',
  'alerts.eventType.payment_paid.desc': '用户 Stripe 付款成功 + Credit 入账',
  'alerts.eventType.user_registered.label': '新用户注册',
  'alerts.eventType.user_registered.desc': '新用户完成注册',
  'alerts.eventType.credit_abnormal.label': 'Credit 异常消耗',
  'alerts.eventType.credit_abnormal.desc': '单用户 1 小时内消耗超阈值',
  'alerts.eventType.task_failed.label': '任务失败',
  'alerts.eventType.task_failed.desc': '画布 / 角色 / 场景 / 分镜出图等任务失败终态',
  'alerts.eventType.daily_report.label': '每日日报',
  'alerts.eventType.daily_report.desc': '每日 09:00 平台数据汇总(注册 / 充值 / 消耗)',

  // ===== 事件状态字典 =====
  'alerts.status.sent.label': '已送达',
  'alerts.status.failed.label': '发送失败',
  'alerts.status.throttled.label': '已节流',

  // ===== 等级 / 来源 =====
  'alerts.level.critical.label': '紧急',
  'alerts.level.warn.label': '警告',
  'alerts.level.info.label': '通知',
  'alerts.source.drama.label': '业务核心 (drama)',
  'alerts.source.auth.label': '用户中心 (auth)',

  // ===== 事件目录 Tab =====
  'alerts.tab.catalog': '事件目录',
  'alerts.catalog.intro': '后端硬编码的全部告警事件清单。配规则前请先在此了解每个事件的触发时机和可用字段。',
  'alerts.catalog.trigger': '触发条件',
  'alerts.catalog.fields': '可用字段(配 conditions / 渲染消息时用)',
  'alerts.catalog.subprojections': '当前订阅',
  'alerts.catalog.noSubprojection': '暂无规则订阅,事件 PUB 后不会推送任何通道',
  'alerts.catalog.stats24h': '过去 24 小时',
  'alerts.catalog.statSent': '已送达',
  'alerts.catalog.statFailed': '失败',
  'alerts.catalog.statThrottled': '节流',
  'alerts.catalog.createRule': '为此事件新建规则',
  'alerts.catalog.emit': '触发一次测试',
  'alerts.catalog.viewEvents': '查看历史记录',
  'alerts.catalog.conditionExample': 'conditions 示例',
  'alerts.catalog.numericHint': '数值字段可加 _min / _max 后缀',
  'alerts.catalog.loadFailed': '加载失败',
  'alerts.catalog.emitOk': '已触发,若有规则订阅会推送到对应通道',
  'alerts.catalog.emitFailed': '触发失败',
  'alerts.catalog.flow': '推送链路',
  'alerts.catalog.detail': '触发条件 / 可用字段',

  // ===== 触发条件文案(自然语言)=====
  'alerts.eventType.provider_error.trigger':
    '某供应商 1 分钟窗口内调用 ≥ 5 次,且失败率 ≥ 50%。命中后本窗口不重复 PUB。',
  'alerts.eventType.stale_recover.trigger':
    '后台扫描发现 status 为 pending / processing 且 updated_at 超过 cutoff(默认 35min)的任务,自动拍 failed 并退款,recovered > 0 时 PUB。',
  'alerts.eventType.llm_limiter.trigger':
    'LLM 限流排队监控 30s 巡检,连续 2 次 waiting ≥ 5 且距上次 PUB > 5min 才触发。',
  'alerts.eventType.health.trigger':
    'auth 每 60s ping auth / drama / gateway 的 /health。状态变化时才推(OK→FAIL 紧急 / FAIL→OK 恢复通知)。',
  'alerts.eventType.payment_paid.trigger':
    'Stripe checkout.session.completed Webhook 入账成功(Credit 已加余额、订单状态置 paid)后 PUB。',
  'alerts.eventType.user_registered.trigger':
    'UserService.CreateUser 注册成功后 PUB(包括邮箱注册 / 手机号注册 / OAuth 登录首次进入)。',
  'alerts.eventType.credit_abnormal.trigger':
    '(预留)周期巡检 credit_ledger_entries,单用户 1 小时内消耗超阈值时 PUB。当前未启用。',
  'alerts.eventType.task_failed.trigger':
    'drama task_worker.notifyFailed 触发(submit 4xx / submit 重试耗尽 / poll 缺 task_id / poll 超龄 / 上游显式失败 等 5 路任一)。',
  'alerts.eventType.daily_report.trigger':
    '每日 UTC 01:00(北京时间 09:00)cron,聚合过去 24h 统计后 PUB 一次。',

  // ===== payload 字段说明 =====
  // provider_error
  'alerts.eventType.provider_error.field.provider': '供应商名(如 apimart / wanx / kling)',
  'alerts.eventType.provider_error.field.error_count': '窗口内失败次数',
  'alerts.eventType.provider_error.field.total_count': '窗口内总调用次数',
  'alerts.eventType.provider_error.field.window_sec': '窗口长度(秒,固定 60)',
  // stale_recover
  'alerts.eventType.stale_recover.field.business': '业务标识(如 canvas_image / character_canonical / scene_sheet)',
  'alerts.eventType.stale_recover.field.recovered': '本次回收的任务条数',
  // llm_limiter
  'alerts.eventType.llm_limiter.field.waiting': '当前排队等位人数',
  'alerts.eventType.llm_limiter.field.holding': '当前持有信号量的活跃调用数',
  'alerts.eventType.llm_limiter.field.max': '配置的并发上限',
  'alerts.eventType.llm_limiter.field.threshold': '触发阈值(默认 5)',
  // health
  'alerts.eventType.health.field.service': '服务名(auth / drama / gateway)',
  'alerts.eventType.health.field.status': '当前状态(ok / down)',
  'alerts.eventType.health.field.error': '错误信息(down 时填,ok 时空)',
  // payment_paid
  'alerts.eventType.payment_paid.field.user_id': '用户 ID(hex)',
  'alerts.eventType.payment_paid.field.user_email': '用户邮箱',
  'alerts.eventType.payment_paid.field.order_no': '订单号',
  'alerts.eventType.payment_paid.field.credits': '到账 Credit 数量',
  'alerts.eventType.payment_paid.field.amount_usd': '支付金额(USD,字符串)',
  'alerts.eventType.payment_paid.field.source': '订单来源(custom 自定义金额 / pack 优惠包)',
  'alerts.eventType.payment_paid.field.pack_code': '优惠包代号(source=pack 时有)',
  // user_registered
  'alerts.eventType.user_registered.field.user_id': '新用户 ID(hex)',
  'alerts.eventType.user_registered.field.user_email': '新用户邮箱',
  'alerts.eventType.user_registered.field.nickname': '昵称',
  // credit_abnormal
  'alerts.eventType.credit_abnormal.field.user_id': '用户 ID(hex)',
  'alerts.eventType.credit_abnormal.field.user_email': '用户邮箱',
  'alerts.eventType.credit_abnormal.field.spent_1h': '过去 1 小时消耗 Credit 数',
  // task_failed
  'alerts.eventType.task_failed.field.kind': '任务类型(canvas_image / canvas_video / character_shot 等 14 种)',
  'alerts.eventType.task_failed.field.job_id': '任务 Job ID',
  'alerts.eventType.task_failed.field.user_id': '触发用户 ID',
  'alerts.eventType.task_failed.field.reason': '失败原因(原文)',
  // daily_report
  'alerts.eventType.daily_report.field.new_users': '过去 24h 新用户数',
  'alerts.eventType.daily_report.field.topup_count': '过去 24h 充值笔数',
  'alerts.eventType.daily_report.field.topup_credits': '过去 24h 充值合计 Credit',
  'alerts.eventType.daily_report.field.credit_spent': '过去 24h 消耗合计 Credit',
};
